import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { MatDialogRef, MatDialog, MAT_DATE_FORMATS, DateAdapter } from "@angular/material";
import { OrderEditFormComponent } from "./order-edit-form/order-edit-form.component";
import { DataTableComponent } from "../datatable/datatable.component";
import { AppService, APP_DATE_FORMATS, AppDateAdapter } from "../../services/app.service";
import { Datatable } from "../../models/datatable.model";
import { OrderService } from "../../services/order.service";
import { ComponentService } from '../../services/component.service';
import { DocumentDetailComponent } from "./document-detail/document-detail.component";
import { OrderCustomsFormComponent } from "./order-customs-form/order-customs-form.component";
import { OrderRemarkComponent } from "../order-remark/order-remark.component";
import { Order } from "../../models/order.model";
import { SharedService } from "../../services/shared";
import { MasterService } from "../../services/master.service";
import { SummaryChartComponent } from "./summary-chart/summary-chart.component";


@Component({
  selector: "app-order",
  templateUrl: "./order.component.html",
  styleUrls: ["./order.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS
    }
  ]
})
export class OrderComponent implements OnInit {
  public data;
  editFormDialogRef: MatDialogRef<OrderEditFormComponent>;
  summaryFormDialogRef: MatDialogRef<SummaryChartComponent>;
  documentDialogRef: MatDialogRef<DocumentDetailComponent>;
  customsFormDialogRef: MatDialogRef<OrderCustomsFormComponent>;
  orderRemarkDialogRef: MatDialogRef<OrderRemarkComponent>;
  @ViewChild('inpDistributor') inpDistributor;
  @ViewChild('filterStatus') filterStatus;
  translations: any = [];
  public length;
  pageIndex: Number = 0;
  pageSize: Number = 10;
  filterText: String = "";
  sortDirection: String = "asc";
  sortHeaderName: String = "OrderNo";
  sortColumnNameById: String = "Id";
  orderStatusList: any = [];
  distributorList: any = [];
  distributorId: Number;    

  filterDateFrom: String = "0";
  filterDateTo: String = "0";
  filterOrderStatus: String = "0";
  filterShipperOrdNo: String = "";
  filterCountryId: String = "0";

  dashboardTileStausId: Number = 0;

  date = new FormControl('', [Validators.pattern(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/)]);
  dateTo = new FormControl('', [Validators.pattern(/^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/)]);
  zeroId = 0;
  constructor(
    private orderService: OrderService,
    public appService: AppService,
    private datatableComponent: DataTableComponent,
    public dialog: MatDialog,
    private datatableProp: Datatable,
    public order: Order,
    private sharedService: SharedService,
    public masterService : MasterService,
    public comService: ComponentService
  ) {
    this.appService.showLoading();
    this.appService.checkSession();
    this.setPageTranslations();
  }

  ngOnInit() {    
    this.bindOrderStatus();
  }

  isNavigatedFromDashboard(){
    this.dashboardTileStausId = parseInt(sessionStorage.getItem("dashStatusId"));
    this.filterOrderStatus = new String(this.dashboardTileStausId);
    this.filterCountryId = sessionStorage.getItem("dashCountryId");
    this.filterStatus.value = this.dashboardTileStausId;
  }

  bindOrderStatus(): void {
    this.masterService.selectSysData("OrderStatus","").subscribe(
        res => this.getOrderStatussSuccess(res),
        error => this.apiFaillure(error)
    );
  }
  getOrderStatussSuccess(res): void {
    if (res.Data != null) {
      this.orderStatusList = JSON.parse(res.Data);
      this.filterStatus.value = 0;
      this.getDistributors();
    } else {
      this.apiFaillure(res.Message);
    }
  }

  setPageTranslations() {
    this.comService.get('order').subscribe((res) => {      
      this.translations = JSON.parse(res['Data']); 
    });
  }

  filterOrders(eleDateFrom, eleDateTo, eleStatus, eleShipperOrdNo){
    this.filterDateFrom = eleDateFrom.value;
    this.filterDateTo = eleDateTo.value;
    this.filterOrderStatus = eleStatus.value;
    this.filterShipperOrdNo = eleShipperOrdNo.value;
    this.data = [];
    this.datatableProp = new Datatable();    
    this.getOrders();
  } 

  filterOrdersChart(eleDateFrom, eleDateTo, eleStatus, eleShipperOrdNo){
    this.filterDateFrom = eleDateFrom.value;
    this.filterDateTo = eleDateTo.value;
    this.filterOrderStatus = eleStatus.value;
    this.filterShipperOrdNo = eleShipperOrdNo.value;
    this.data = [];
    this.datatableProp = new Datatable();    
    this.getOrdersSummary();
  } 

  clearDate(dtControl, dtPicker){
     dtControl.value = '';
     dtPicker._datepickerInput._value = '';
  }

  getOrders(): void {
    //this.getAllUserSuccess(this.orderService.all());

    this.filterDateFrom = this.filterDateFrom != "" && this.filterDateFrom.length == 10 ? this.filterDateFrom.split('/').join('-') : "0";
    this.filterDateTo = this.filterDateTo != "" && this.filterDateTo.length == 10 ? this.filterDateTo.split('/').join('-') : "0";
    this.filterOrderStatus = this.filterOrderStatus != undefined && this.filterOrderStatus != "" ? this.filterOrderStatus : "0";
    this.filterShipperOrdNo = this.filterShipperOrdNo != undefined && this.filterShipperOrdNo != "" ? this.filterShipperOrdNo : "!";

    this.appService.showLoading();
    this.orderService.all(this.pageIndex, this.pageSize, this.sortColumnNameById, this.sortDirection, this.filterText, this.filterDateFrom, this.filterDateTo, this.filterOrderStatus,
        this.filterShipperOrdNo, this.distributorId, this.filterCountryId).subscribe(
        res => this.getOrdersSuccess(res),
        error => this.apiFaillure(error)
    );
  }

  getOrdersSummary(): void {
    //this.getAllUserSuccess(this.orderService.all());

    this.filterDateFrom = this.filterDateFrom != "" && this.filterDateFrom.length == 10 ? this.filterDateFrom.split('/').join('-') : "0";
    this.filterDateTo = this.filterDateTo != "" && this.filterDateTo.length == 10 ? this.filterDateTo.split('/').join('-') : "0";
    this.filterOrderStatus = this.filterOrderStatus != undefined && this.filterOrderStatus != "" ? this.filterOrderStatus : "0";
    this.filterShipperOrdNo = this.filterShipperOrdNo != undefined && this.filterShipperOrdNo != "" ? this.filterShipperOrdNo : "!";

    this.appService.showLoading();
    this.orderService.summary(this.pageIndex, this.pageSize, this.sortColumnNameById, this.sortDirection, this.filterText, this.filterDateFrom, this.filterDateTo, this.filterOrderStatus,
        this.filterShipperOrdNo, this.distributorId, this.filterCountryId).subscribe(
        res => this.getOrdersSummarySuccess(res),
        error => this.apiFaillure(error)
    );
  }
  getOrdersSummarySuccess(res): void {
    this.data = [];
    if (res.Status == 1) {
      
      this.data = JSON.parse(res.Data).Table;
      this.summaryFormDialogRef = this.dialog.open(SummaryChartComponent, {
        disableClose: true,
        data: this.data,
        panelClass: "my-dialog"
      });
      this.summaryFormDialogRef.afterClosed().subscribe(response => {
        this.appService.showLoading();
        this.data = "";
        this.getOrders();
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  getOrdersSuccess(res): void {
    debugger;
    this.data = [];
    if (res.Status == 1) {
      this.data = JSON.parse(res.Data).Table;
      this.datatableProp = this.appService.mapDataTablePropWithIndicators(
        this.datatableProp,
        JSON.parse(res.Data).Table1[0],
        '|D_Remark|S_Remark|'
      );
      this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
      this.datatableProp.columnKeyData = JSON.parse(res.Data).Table3;
      this.length = this.data.length == 0 ? 0 : JSON.parse(res.Data).Table[0].MaxRowNumber;
      this.sharedService.Data.next(this.data);
      this.appService.hideLoading();
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  apiFaillure(error): void {
    this.appService.showLoading();
    this.appService.showDialogue("Error", this.translations[error]);
  }

  editRecord(e): void {
    this.appService.showLoading();
    this.orderService.select(e.currentTarget.id).subscribe(
        res => this.selectSuccess(res,false),
        error => this.apiFaillure(error)
    );
  }
  viewRecord(e):void{
    debugger;
    this.appService.showLoading();
    this.orderService.select(e.currentTarget.id).subscribe(
        res => this.selectSuccess(res,true),
        error => this.apiFaillure(error)
    );
  }
  selectSuccess(res,viewMode : boolean = false): void {
    if (res.Status == 1) {
      this.order = JSON.parse(res.Data)[0];
      this.order.D_LicensePlate = this.order.D_LicensePlate == '' ? '-' : this.order.D_LicensePlate;
      this.order.D_T2No =  this.order.D_T2No == '' ? '-' : this.order.D_T2No;
      
      sessionStorage.setItem("ViewMode",viewMode.toString());
      this.editFormDialogRef = this.dialog.open(OrderEditFormComponent, {
        disableClose: true,
        data: this.order,                
        panelClass: "my-dialog"
      });
      this.editFormDialogRef.afterClosed().subscribe(response => {
        this.appService.showLoading();
        this.data = "";        
        this.getOrders();
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
    //this.appService.hideLoading();
  }

  deleteRecord(e): void {
    if (typeof this.translations.hdConfirm == "undefined") {
      this.setPageTranslations();
    }
    var orderId = e.currentTarget.id;
    this.appService.showDialogue(this.translations.hdConfirm, this.translations.confrimMessage, true).afterClosed().subscribe(result => {
        if (result) {
          this.appService.showLoading();
          this.deleteConfirm(orderId);
        }
    });
  }

  deleteConfirm(userId) {
    this.orderService.delete(userId).subscribe(
        res => this.deleteSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  deleteSuccess(res) {
    if (res.Status == 1) {
      this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message]).afterClosed().subscribe(result => {
          if (result) {
            this.appService.hideLoading();
            this.data = "";
            this.getOrders();
          }
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  changeRecord(e): void {
    this.documentDialogRef = this.dialog.open(DocumentDetailComponent, {
      disableClose: true
    });
  }

  openCustomsDialog(e, type) {
    this.appService.showLoading();
    var actionType = e.target.getAttribute("class");
    actionType = actionType.replace("mat-icon material-icons ", "");
    if (actionType == "Documents") {
      sessionStorage.setItem('orderId', e.currentTarget.id);
      this.orderService.select(e.currentTarget.id).subscribe(
          res => this.selectDocumentSuccess(res),
          error => this.apiFaillure(error)
      );
    } else {
      this.orderService.select(e.currentTarget.id).subscribe(
          res => this.selectCustomSuccess(res),
          error => this.apiFaillure(error)
      );
    }
  }


  selectDocumentSuccess(res) {
    if (res.Status == 1) {
      this.order = JSON.parse(res.Data)[0];
      this.documentDialogRef = this.dialog.open(DocumentDetailComponent, {
        disableClose: true,
        panelClass: "my-dialog",
        data: this.order
      });
      this.documentDialogRef.afterClosed().subscribe(response => {
        this.appService.showLoading();
        this.data = "";
        this.getOrders();
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  selectCustomSuccess(res) {
    if (res.Status == 1) {
      this.order = JSON.parse(res.Data)[0];
      this.customsFormDialogRef = this.dialog.open(OrderCustomsFormComponent, {
        disableClose: true,
        data: this.order,
        panelClass: "my-dialog"
      });
      this.customsFormDialogRef.afterClosed().subscribe(response => {
        this.appService.showLoading();
        this.data = "";
        this.getOrders();
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  addRecord(): void {
    this.order = new Order();
    this.order.RegistrationDate = new Date();
    this.order.Status = 151;
    this.order.TypeId = 161;
    this.order.D_LicensePlate = '-';
    this.order.D_T2No = '-';
    this.editFormDialogRef = this.dialog.open(OrderEditFormComponent, {
      disableClose: true,
      data: this.order,
      panelClass: "my-dialog"
    });
    this.editFormDialogRef.afterClosed().subscribe(response => {
      this.appService.showLoading();
      this.data = "";
      this.getOrders();
    });
  }

  getServerData(event) {
    
    this.datatableProp = new Datatable();
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getOrders();    
  }

  applyFilter(filterValue: any) {
    this.datatableProp = new Datatable();
    this.filterText = filterValue;
    this.getOrders();
  }

  getSortedData(event) {
    this.datatableProp = new Datatable();
    this.sortColumnNameById = event.currentTarget.getAttribute("id");
    this.getOrders();
  }

  openRemarkEditor(event){
    this.orderRemarkDialogRef = this.dialog.open(OrderRemarkComponent, {
        disableClose: true,
        data: event,
        panelClass: "my-dialog"
    });

    this.orderRemarkDialogRef.afterClosed().subscribe(result => {
      this.appService.showLoading();
      this.data = "";
      this.getOrders()
    });
  }

  getDistributors(){
      this.orderService
      .getDistributors()
      .subscribe(
        res => this.distributorSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  distributorSuccess(res){
    if (res.Data != null) {
      this.distributorList = JSON.parse(res.Data).Table;
      this.inpDistributor.value = this.inpDistributor.value == undefined ? 0 : this.inpDistributor.value;
      this.distributorId = this.inpDistributor.value;
      this.isNavigatedFromDashboard();
      this.getOrders();
    } else {
      this.apiFaillure(res.Message);
    }
  }

}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order.component.ts